import { apolloClient } from '~/apollo-client';
import { Flex_FetchIpaContractQuery, Flex_FetchIpaContractQueryVariables } from '~/typings/graphql';
import { SignNowEnvelopeStatus } from '~/typings/signnow';
import { FETCH_IPA_CONTRACT } from './fetch-ipa-contract.queries';

interface FetchIpaContractParams {
  utilityAccountId: number;
}

export interface FetchIpaContractResponse {
  ipaContractEnvelope:
    | {
        id: number;
        status?: SignNowEnvelopeStatus | null;
        url?: string | null;
        personalizedContractId?: number;
        inviteExpiresAt?: string | null;
      }
    | Record<string, never>; // Empty object {} instead of null
}

export const fetchIpaContract = async (
  params: FetchIpaContractParams,
): Promise<FetchIpaContractResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchIpaContractQuery,
    Flex_FetchIpaContractQueryVariables
  >({
    fetchPolicy: 'no-cache', // machine polls this query
    query: FETCH_IPA_CONTRACT,
    variables: {
      utilityAccountId: params.utilityAccountId,
    },
  });

  const envelope = data.signNowEnvelopeByUtilityAccount;

  // If no envelope exists, return empty object (like how DocuSign returns empty array)
  if (!envelope) {
    return {
      ipaContractEnvelope: {}, // Empty object is truthy, won't trigger onError
    };
  }

  return {
    ipaContractEnvelope: {
      id: envelope.id,
      status: envelope.status as SignNowEnvelopeStatus,
      url: envelope.signingUrl || undefined, // Convert null to undefined
      personalizedContractId: envelope.personalizedContractId,
      inviteExpiresAt: envelope.inviteExpiresAt || undefined,
    },
  };
};
